import { Application, Container, Graphics } from 'pixi.js';
import { TOKENS } from '../tokens';

/**
 * Simple cursor with outer ring and center dot. Handles its own spring
 * scaling animation and a brief additive shadow flash on press.
 */
export default class Cursor extends Container {
  private app: Application;
  private ring: Graphics;
  private dot: Graphics;
  private shadow: Graphics;
  private velocity = 0;
  private shadowTime = 0;

  constructor(app: Application) {
    super();
    this.app = app;

    const color = parseInt(TOKENS.text.slice(1), 16);
    const r = TOKENS.cursor.r;

    this.shadow = new Graphics();
    this.shadow.circle(0, 0, r).fill({ color, alpha: 0.5 });
    this.shadow.alpha = 0;
    this.shadow.blendMode = 'add';

    this.ring = new Graphics();
    this.ring.circle(0, 0, r).stroke({ width: 2, color });

    this.dot = new Graphics();
    this.dot.circle(0, 0, 4).fill({ color });

    this.addChild(this.shadow, this.ring, this.dot);

    this.app.ticker.add(this.update, this);
  }

  /** Trigger click animation. */
  press(): void {
    this.scale.set(0.9);
    this.velocity = 0;
    this.shadow.alpha = 0.8;
    this.shadow.scale.set(1);
    this.shadowTime = 0;
  }

  private update(): void {
    const target = 1;
    const stiffness = 0.3;
    const damping = 0.8;
    const s = this.scale.x;
    this.velocity += (target - s) * stiffness;
    this.velocity *= damping;
    const newScale = s + this.velocity;
    this.scale.set(newScale);

    if (this.shadow.alpha > 0) {
      this.shadowTime += this.app.ticker.deltaMS;
      const progress = this.shadowTime / 80;
      this.shadow.alpha = Math.max(0.8 * (1 - progress), 0);
      this.shadow.scale.set(1 + progress * 0.3);
    }
  }

  override destroy(options?: boolean | { children?: boolean; texture?: boolean; baseTexture?: boolean }): void {
    this.app.ticker.remove(this.update, this);
    super.destroy(options);
  }
}
